module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header', [_c('h1', [_vm._v("Get in contact")])]), _vm._v(" "), _c('main', {
    staticClass: "wrap",
    class: _vm.$style.contact
  }, [_c('p', {
    class: _vm.$style.intro
  }, [_vm._v("Please do not hesitate to get in touch with me using the form below or "), _c('a', {
    attrs: {
      "href": "mailto:r.blything@gmail.com?subject=Work%20enquiry"
    }
  }, [_vm._v("sending an email")]), _vm._v(" to discuss your design ideas; pre-production sound needs; sound effects available from my library, specific field sound requirements or any sound editing projects, I’ll be pleased to get involved.")]), _vm._v(" "), _c('form', {
    class: _vm.$style.form,
    attrs: {
      "action": "https://formspree.io/r.blything@gmail.com",
      "method": "POST"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('label', [_c('span', [_vm._v("How can I help you?")]), _vm._v(" "), _c('textarea', {
    ref: "enquiry",
    attrs: {
      "name": "enquiry",
      "rows": "1",
      "required": ""
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "_subject",
      "value": "Contact enquiry from rickblything.net"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "_next",
      "value": "/about"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "name": "_gotcha"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "name"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Email address (required)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "name": "email",
      "required": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51beda60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contact.vue
// module id = 113
// module chunks = 2